import { Nav, NavItem, NavLink } from "reactstrap";
import { Contact, Href, Inbox, Home } from "../../Utils/Constants";

type propsType = {
    basicTab: string;
    setBasicTab: (data: string) => void;
    employeeIdProp?: number;
}

export default function BorderNav({ basicTab, setBasicTab, employeeIdProp }: propsType) {
    // console.log(employeeIdProp, 'employeeId in navtab');

    return (
        <Nav tabs className='border-tab nav-info mb-0'>
            <NavItem>
                <NavLink href="#" className={`nav-border txt-info tab-info ${basicTab === '1' ? 'active' : ''}`} onClick={() => setBasicTab('1')}><i className="icofont icofont-ui-home" />{'User'}</NavLink>
            </NavItem>
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '2' ? 'active' : ''}`} onClick={() => setBasicTab('2')}><i className="icofont icofont-ui-message" />{'Attendance'}</NavLink>
            </NavItem>}
            {employeeIdProp &&  <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '3' ? 'active' : ''}`} onClick={() => setBasicTab('3')}><i className="icofont icofont-man-in-glasses" />{'Reporting'}</NavLink>
            </NavItem>}
            {employeeIdProp &&  <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '4' ? 'active' : ''}`} onClick={() => setBasicTab('4')}><i className="icofont icofont-ui-message" />{'Inputs'}</NavLink>
            </NavItem>}
            {employeeIdProp &&  <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '5' ? 'active' : ''}`} onClick={() => setBasicTab('5')}><i className="icofont icofont-ui-message" />{'Leaves'}</NavLink>
            </NavItem>}

        </Nav>
    )
}
